import englishMessages from "ra-language-english";
import polyglotI18nProvider from "ra-i18n-polyglot";
import fa_IR from "../Constants/fa_IR";

export const i18nProvider = polyglotI18nProvider(
  (locale) => (locale === "en" ? englishMessages : fa_IR),
  "fa" // Default locale
);
